import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import {
    StoreType,
    setLifecyclePhaseReloadActive,
    setLifecycleConnectionReloadActive,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Delimiter,
} from "client/components"

import PhaseForm from "./phaseForm"
import ConnectionForm from "./connectionForm"
import ConfirmDeletePhase from "./confirmDeletePhase"
import ConfirmDeleteConnection from "./confirmDeleteConnection"

import {
    InspectorWrapper,
    InspectorEmptySpan,
} from "../styled"

const Inspector = () => {
    const activePhase = useSelector((state: StoreType) => state.lifecycle.model.activePhase)
    const reloadActivePhase = useSelector((state: StoreType) => state.lifecycle.model.reloadActivePhase)

    const activeConnection = useSelector((state: StoreType) => state.lifecycle.model.activeConnection)
    const reloadConnectionEdit = useSelector((state: StoreType) => state.lifecycle.model.reloadActiveConnection)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setLifecyclePhaseReloadActive(false))
        setTimeout(() => {
            dispatch(setLifecyclePhaseReloadActive(true))
        }, 0)
    }, [activePhase])

    useEffect(() => {
        dispatch(setLifecycleConnectionReloadActive(false))
        setTimeout(() => {
            dispatch(setLifecycleConnectionReloadActive(true))
        }, 0)
    }, [activeConnection])


    return (
        <InspectorWrapper>
            {
                activePhase
                && reloadActivePhase
                && <PhaseForm phase={activePhase} />
            }

            {
                activeConnection
                && reloadConnectionEdit
                && <ConnectionForm connection={activeConnection} />
            }

            {
                !activePhase
                && !activeConnection
                && (
                    <PageForm>
                        <Row>
                            <Col xs={12}>
                                <FormGroup>
                                    <Label>{lang.inspector}</Label>
                                </FormGroup>

                                <Delimiter size="sm" />

                                <InspectorEmptySpan>
                                    {lang.selectElement}
                                </InspectorEmptySpan>
                            </Col>
                        </Row>
                    </PageForm>
                )
            }

            <ConfirmDeletePhase />
            <ConfirmDeleteConnection />
        </InspectorWrapper>
    )
}
export default Inspector
